import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "sticky-top-20" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h5", {
    class: "title",
    style: { "padding-left": "16px", "margin-bottom": "0px" }
}, "Service", -1);
const _hoisted_3 = { class: "container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_portal = _resolveComponent("portal");
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_g_treeview = _resolveComponent("g-treeview");
    const _component_router_view = _resolveComponent("router-view");
    const _component_g_content_page = _resolveComponent("g-content-page");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_portal, {
            to: "command-bar",
            order: 900
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.OnRefresh($event)))
                    }, _toDisplayString(_ctx.$tc('client.Common.Refresh')), 1)
                ])
            ]),
            _: 1
        }),
        _createVNode(_component_g_content_page, null, {
            title: _withCtx(() => [
                _createVNode(_component_g_breadcrumb)
            ]),
            sidebar: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_g_treeview, {
                        class: "mb-4",
                        "data-source": _ctx.serviceMenu,
                        "data-structure": "tree"
                    }, null, 8, ["data-source"])
                ])
            ]),
            content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_router_view)
                ])
            ]),
            _: 1
        })
    ], 64));
}
